module.exports = __webpack_public_path__ + "static/media/personality-assessment.221ff976.png";